import ArrowRightOutlinedIcon from "@mui/icons-material/ArrowRightOutlined";
import styles from "./NavigationBar.module.css";
import "../../config/colors.css";
import { MenuItem, Select, SelectChangeEvent, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { SetCurrentTheme, GetThemeName } from "./ThemeComponent";

interface NavigationbarProps {
  menuTitle?: string;
  title: string;
  screenTitle?: string;
  text: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const NavigationBar: React.FC<NavigationbarProps> = ({
  menuTitle,
  title,
  screenTitle,
  text,
  buttonText,
  onButtonClick,
}) => {
  const [theme, setTheme] = useState("dark");

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleThemeChange = (event: SelectChangeEvent) => {
    SetCurrentTheme(event.target.value);
    setTheme(event.target.value);
  };
  useEffect(() => {
    setTheme(GetThemeName());
  }, [theme]);
  return (
    <div className={styles.topbar}>
      <div
        className="pull-left"
        style={{ marginLeft: menuTitle ? ".7em" : "15px", fontSize: "11px" }}
      >
        <div className="bCrumb">
          <span style={{ display: "contents" }}>{menuTitle}</span>
          <ArrowRightOutlinedIcon />
          <span style={{ display: "contents" }}>{title}</span>
          {screenTitle && (
            <>
              <ArrowRightOutlinedIcon />
              <span>{screenTitle}</span>
            </>
          )}
        </div>
        <h6
          style={
            menuTitle
              ? { marginLeft: "0em", fontSize: "14px", fontWeight: "bold" }
              : { marginLeft: ".5em", fontSize: "14px", fontWeight: "bold" }
          }
        >
          {text}
        </h6>
        {buttonText != "Active" && onButtonClick && (
          <Button
            variant="primary"
            onClick={onButtonClick}
            style={{
              marginLeft: "0.625em",
              height: "2.1875em",
            }}
          >
            {buttonText}
          </Button>
        )}
        {buttonText === "Active" && onButtonClick && (
          <Button
            variant="primary"
            onClick={onButtonClick}
            style={{
              marginLeft: "0.625em",
              height: "2.1875em",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Form.Check
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              style={{ marginRight: "0.625em" }}
            />
            {buttonText}
          </Button>
        )}
      </div>
      <div className="pull-right" style={{ marginRight: "1em" }}>
        <div className={styles.tooltipcontainer}>
          <Tooltip
            title="Select your Theme"
            arrow
            placement="top"
            style={{ fontSize: "11px" }}
          >
            <Select
              value={theme}
              className={styles.select}
              onChange={handleThemeChange}
              sx={{
                fontSize: "11px",
                height: "2em",
                minWidth: "6.25em",
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: "11px",
                      padding: "0.5em 1em",
                    },
                  },
                },
              }}
            >
              <MenuItem value={"light"}>Light</MenuItem>
              <MenuItem selected value={"dark"}>
                Dark
              </MenuItem>
              <MenuItem value={"green"}>Green</MenuItem>
            </Select>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
